import androidx.compose.runtime.Composable
import net.sergeych.ugdx.shared.trader.HistoryInterval
import net.sergeych.ugdx.shared.trader.StatSampleRate
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.dom.*

class StatAttrsBuilder {
    var onChange: (value: StatSampleRate?) -> Unit = {}
    var label: @Composable() () -> Unit = {}
    var options: List<StatSampleRate> = StatSampleRate.values().toList()
    var isCondensed = false

    fun onChange(handler: (value: StatSampleRate?) -> Unit) { onChange = handler }
    fun label(l: @Composable() () -> Unit) { label = l }
    fun condensed() { isCondensed = true }
}

@Composable
fun StatSampleRateSelect(
    id: String,
    selected: StatSampleRate?,
    attrs: StatAttrsBuilder.() -> Unit = {}
) {
    val builder = StatAttrsBuilder()
    attrs.invoke(builder)

    Div() {
        if (!builder.isCondensed) Label(forId = id, attrs = {
            classes("block", "text-sm", "font-medium", "text-gray-700")
        }) { builder.label() }

        Select(attrs = {
            id(id)
            name("select")
            classes("mt-1", "block", "w-full", "pl-3", "pr-10",
                if (builder.isCondensed) "py-1" else "py-2",
                "text-base", "border-gray-300", "focus:outline-none", "focus:ring-indigo-500", "focus:border-indigo-500", "sm:text-sm", "rounded-md")
            onChange {
                val id = it.value
                val type = builder.options.find { it.toString() == id }
                builder.onChange(type)
            }
        }) {
            builder.options.filter{it != StatSampleRate.REALTIME}.forEach {
                val option = it

                Option(option.toString(), attrs = {
                    if (selected?.toString() == option.toString()) selected()
                }) { Text(option.toString()) }
            }
        }
    }
}